import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  image?: string;
}
export const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  author,
  role,
  image
}) => {
  return <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative" data-id="element-195">
      <Quote className="w-10 h-10 text-blue-100 absolute top-6 left-6 -z-0" data-id="element-196" />
      <div className="relative z-10" data-id="element-197">
        <p className="text-gray-700 text-lg leading-relaxed mb-6 italic" data-id="element-198">
          "{quote}"
        </p>
        <div className="flex items-center" data-id="element-199">
          {image ? <img src={image} alt={author} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-200" /> : <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4 text-blue-600 font-bold text-lg" data-id="element-201">
              {author.charAt(0)}
            </div>}
          <div data-id="element-202">
            <div className="font-bold text-[#0A2540]" data-id="element-203">{author}</div>
            <div className="text-sm text-gray-500" data-id="element-204">{role}</div>
          </div>
        </div>
      </div>
    </div>;
};